import { useTranslation } from 'react-i18next';
import type { ErrorCode } from '@unit/shared';

/**
 * Renders a failed API call.
 *
 * The server never sends a user-facing string — it sends a typed code, and the
 * message comes from this app's own catalogue in the reader's language. The
 * request id is shown beside it, isolated as Latin script so the bidi algorithm
 * does not reverse it inside the Hebrew sentence (REQUIREMENTS §2.8).
 */
export function ApiError({ code, requestId }: { code: ErrorCode; requestId?: string }) {
  const { t } = useTranslation();

  return (
    <p role="alert" data-testid="api-error" className="text-sm text-red-600">
      {t(`errors.${code}`)}
      {requestId && <span className="latin-inline ms-2 text-slate-400">{requestId}</span>}
    </p>
  );
}
